
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./kach-commons.cjs.production.min.js')
} else {
  module.exports = require('./kach-commons.cjs.development.js')
}
